import { render, staticRenderFns } from "./processAccidentReception.vue?vue&type=template&id=1c86a811"
import script from "./processAccidentReception.vue?vue&type=script&lang=js"
export * from "./processAccidentReception.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c86a811')) {
      api.createRecord('1c86a811', component.options)
    } else {
      api.reload('1c86a811', component.options)
    }
    module.hot.accept("./processAccidentReception.vue?vue&type=template&id=1c86a811", function () {
      api.rerender('1c86a811', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/rec/processAccidentReception.vue"
export default component.exports